'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _ngSortable = require('ng-sortable');

var _ngSortable2 = _interopRequireDefault(_ngSortable);

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _getFeisDays = require('util/getFeisDays');

var _getFeisDays2 = _interopRequireDefault(_getFeisDays);

var _reportsCsv = require('reports-csv');

var _reportsCsv2 = _interopRequireDefault(_reportsCsv);

var _stages = require('ifeis-isomorphic/lib/redux/actions/stages');

var _paths = require('ifeis-isomorphic/lib/redux/actions/stages/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _mapStateToStageSchedule = require('util/mapStateToStageSchedule');

var _mapStateToStageSchedule2 = _interopRequireDefault(_mapStateToStageSchedule);

var _syllabus = require('syllabus');

var _prompt = require('prompt');

var _prompt2 = _interopRequireDefault(_prompt);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StageScheduleController = function () {
  function StageScheduleController($rootScope, feis, fPrompt, $mdDialog, $mdMedia, $ngRedux, $mdSidenav, $scope, $timeout, fEventEditor, $filter, msgService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, StageScheduleController);

    this.feis = feis;

    this.isLoading = true;
    this.selected = (0, _immutable.List)();
    this.events = (0, _immutable.List)();
    this.filteredUnscheduled = (0, _immutable.List)();

    this._ = {
      $mdDialog: $mdDialog,
      $mdMedia: $mdMedia,
      $ngRedux: $ngRedux,
      $mdSidenav: $mdSidenav,
      $scope: $scope,
      $timeout: $timeout,
      fPrompt: fPrompt,
      fEventEditor: fEventEditor,
      $filter: $filter,
      msgService: msgService,
      fCSVReportsService: fCSVReportsService
    };

    this.days = (0, _getFeisDays2.default)(this.feis);
    this.refreshPromptShown = false;

    $ngRedux.dispatch((0, _stages.getSchedule)(feis.id));
    $ngRedux.dispatch((0, _stages.getUnscheduledEvents)(feis.id));

    var mapSchedule = (0, _mapStateToStageSchedule2.default)(feis.id);
    $ngRedux.connect(function (state) {
      var schedule = mapSchedule(state);

      if (schedule.loading) {
        return { isLoading: true };
      }

      if (schedule.error) {
        return { error: true };
      }

      return _extends({}, schedule, {
        isLoading: schedule.loading || (0, _paths.unscheduledEventsAreLoading)(state, feis.id),
        filteredUnscheduled: _this._filterEvents(schedule.unscheduledEvents, _this.searchFilter),
        selected: (0, _immutable.List)(),
        events: (0, _paths2.getEvents)(state, feis.id)
      });
    })(this);

    this._.$scope.$watch(function () {
      return _this.error;
    }, function (newVal, oldVal) {
      if (newVal && !_this.refreshPromptShown) {
        _this.refreshPromptShown = true;
        _this.showSyncErrorModal();
      }
    });

    /**
     * Put in a placeholder, e.g. after it's been dragged away.
     */
    this.placeholderTemplate = (0, _immutable.Map)({ placeholder: 1 });
    this.placeholders = [];
    this.resetPlaceholder();

    this.selectedEvents = [];

    this.sortableOptions = {
      itemMoved: function itemMoved() {
        return _this._dragHandler.apply(_this, arguments);
      },
      orderChanged: function orderChanged() {
        return _this._dragHandler.apply(_this, arguments);
      }
    };
  }

  _createClass(StageScheduleController, [{
    key: 'showSyncErrorModal',
    value: function showSyncErrorModal() {
      this._.$mdDialog.show({
        template: require('./sync-error-dialog.html'),
        clickOutsideToClose: false,
        escapeToClose: false,
        parent: angular.element(document.body),
        bindToController: true,
        controllerAs: '$ctrl',
        locals: {
          reload: function reload() {
            return window.location.reload();
          }
        },
        controller: function controller() {
          this.reload = function () {
            return window.location.reload();
          };
        }
      });

      // reload after 10 seconds if user has not interacted with dialog
      this._.$timeout(function () {
        window.location.reload();
      }, 10000);
    }
  }, {
    key: 'toggleLeftNav',
    value: function toggleLeftNav() {
      this._.$mdSidenav('left').toggle();
    }
  }, {
    key: 'throwError',
    value: function throwError(msg) {
      this._.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'resetPlaceholder',
    value: function resetPlaceholder() {
      this.placeholders.push(angular.copy(this.placeholderTemplate));
    }
  }, {
    key: 'downloadSchedule',
    value: function downloadSchedule() {
      var _this2 = this;

      var maxEvents = 0;

      this.eventsByStage.forEach(function (eventsForAStage) {
        if (maxEvents < eventsForAStage.size) {
          maxEvents = eventsForAStage.size;
        }
      });

      var csv = [];

      var sortedStages = this.stages.sort(function (a, b) {
        var aCat = a.get('dt') + a.get('name');
        var bCat = b.get('dt') + b.get('name');
        return aCat.localeCompare(bCat);
      });

      var days = sortedStages.map(function (stage) {
        return (0, _moment2.default)(stage.get('dt')).tz(_this2.feis.tz).format('MM/DD/YYYY');
      });

      csv.push(days);

      var stages = sortedStages.map(function (stage) {
        return stage.get('name');
      });
      csv.push(stages);

      var _loop = function _loop(row) {
        var values = sortedStages.map(function (stage) {
          var events = _this2.eventsByStage.get(stage.get('id')) || (0, _immutable.List)();
          var participants = !events.getIn([row, 'placeholder']) && events.getIn([row, 'participants']) >= 0 ? '(' + events.getIn([row, 'participants']) + ')' : '';
          var eventName = events.getIn([row, 'name']) || '';
          return eventName + ' ' + participants;
        });

        csv.push(values);
      };

      for (var row = 0; row < maxEvents; row++) {
        _loop(row);
      }

      this._.fCSVReportsService.prepareCSV(csv, 'Stage_Schedule_' + this.feis.name + '.csv');
    }
  }, {
    key: 'addStage',
    value: function addStage($event) {
      var _this3 = this;

      this._.$mdDialog.show({
        controller: function controller($scope, locals) {
          $scope.days = locals.days;
          $scope.newStage = {
            name: '',
            date: 0
          };
          $scope.cancel = function () {
            return _this3._.$mdDialog.cancel();
          };
          $scope.create = function (newStage) {
            return _this3._.$mdDialog.hide(newStage);
          };
        },
        template: require('./newStage.tmpl.html'),
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: true,
        fullscreen: this._.$mdMedia('xs'),
        locals: {
          days: this.days
        }
      }).then(function (stage) {
        return _this3._.$ngRedux.dispatch((0, _stages.createStage)(_this3.feis.id, {
          name: stage.name,
          dt: parseInt(stage.date, 10)
        }));
      });
    }
  }, {
    key: 'isSelected',
    value: function isSelected(event) {
      return !!this.selected.find(function (id) {
        return id === event.get('id');
      });
    }
  }, {
    key: '_filterEvents',
    value: function _filterEvents() {
      var _this4 = this;

      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.List)();
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (!events || events.size === 0) {
        return events;
      }

      return events.filter(function (event) {
        if (!_this4.searchFilter) {
          return true;
        }

        var searchFilter = filter.toLowerCase();

        var type = 'grades';
        switch (event.get('type')) {
          case 'C':
            type = 'championships';
            break;
          case 'F':
            type = 'figures';
            break;
          case 'S':
            type = 'specials';
            break;
        }

        if (type.indexOf(filter) !== -1) {
          return true;
        }

        var propMatches = function propMatches(prop) {
          return typeof prop === 'string' && prop.toLowerCase().indexOf(filter) !== -1;
        };

        if (event.some(propMatches)) {
          return true;
        }

        return false;
      });
    }
  }, {
    key: 'filterUnscheduledEvents',
    value: function filterUnscheduledEvents() {
      this.filteredUnscheduled = this._filterEvents(this.unscheduledEvents, this.searchFilter);
    }
  }, {
    key: 'renameStage',
    value: function renameStage($event, stage) {
      var _this5 = this;

      var name = stage.get('name');

      this._.fPrompt({
        action: 'Rename',
        title: 'Rename ' + name,
        label: 'Stage Name',
        value: name
      }, $event).then(function (name) {
        var data = stage.toJS();
        data.name = name;
        _this5._.$ngRedux.dispatch((0, _stages.updateStage)(_this5.feis.id, data.id, data));
      });
    }
  }, {
    key: 'removeStage',
    value: function removeStage($event, stage) {
      var _this6 = this;

      var $mdDialog = this._.$mdDialog;


      var confirm = $mdDialog.confirm().title('Are you sure?').textContent('If you delete this stage, its entire schedule will be lost forever and the events will be moved back to Unscheduled.').ok('Delete').cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        return _this6._.$ngRedux.dispatch((0, _stages.deleteStage)(_this6.feis.id, stage.get('id')));
      });
    }
  }, {
    key: 'showEvent',
    value: function showEvent($event, event) {
      if (event.get('placeholder')) {
        return this.add(event.get('placeholder').toJS());
      }

      return this._.fEventEditor($event, this.feis.id, event.get('id'), event);
    }
  }, {
    key: 'select',
    value: function select($event, item) {
      // if unchecking an item, remove it from the list and we're done.
      if (this.isSelected(item)) {
        this.selected = this.selected.filter(function (e) {
          return e !== item.get('id');
        });
        return;
      }

      // if we already have 2 items in the list, uncheck and remove the oldest.
      if (this.selected.count() >= 2) {
        this.selected = this.selected.shift();
      }

      // add the newly-checked item.
      this.selected = this.selected.push(item.get('id'));
    }
  }, {
    key: 'canMerge',
    value: function canMerge() {
      return this.selected.count() === 2;
    }

    // merge ( $event ) {
    //   const a = this.getEvent( this.selectedEvents[0].id ).toJS();
    //   const b = this.getEvent( this.selectedEvents[1].id ).toJS();

    //   const tpl = angular.copy( a );
    //   tpl.name = `${a.name}-${b.name}`;
    //   delete tpl.id;

    //   return this._.fEventEditor( $event, tpl, {
    //     merge: { a, b },
    //     split: false
    //   });
    // }

  }, {
    key: 'merge',
    value: function merge($event) {
      var _this7 = this;

      if (!this.canMerge()) {
        console.error('we need two items to do a merge');
        return;
      }

      var a = this.events.find(function (ev) {
        return ev.get('id') === _this7.selected.get(0);
      });
      var b = this.events.find(function (ev) {
        return ev.get('id') === _this7.selected.get(1);
      });

      var tpl = (0, _immutable.Map)().merge(a).merge(b).set('name', a.get('name') + '-' + b.get('name')).set('groupFeeId', a.get('groupFeeId') || b.get('groupFeeId')).delete('id');

      return this._.fEventEditor($event, this.feis.id, null, tpl, {
        merge: { a: a, b: b },
        split: false
      });
    }
  }, {
    key: '_dragHandler',
    value: function _dragHandler(event) {
      var sourceList = event.source.sortableScope.modelValue;
      var targetList = event.dest.sortableScope.modelValue;
      var item = event.source.itemScope.modelValue;

      /**
       * FIXME(jdm): This is gross. In order to know to which lists we are dragging and dropping, I
       * had to use an ngInit and set a property manually. This violates SoC and should be fixed.
       */
      var sourceStage = event.source.sortableScope.$$stage;
      var targetStage = event.dest.sortableScope.$$stage;

      var targetIndex = event.dest.index;

      var detach = false;
      var attach = false;
      var before = void 0,
          after = void 0;

      if (sourceList === this.placeholders) {
        this.resetPlaceholder();
      } else if (sourceStage && sourceStage !== this.unscheduled) {
        detach = true;
      }

      if (targetStage && targetStage !== this.unscheduled) {
        attach = true;
        before = targetList[targetIndex - 1];
        after = targetList[targetIndex + 1];
      }

      if (detach) {
        if (attach) {
          this._.$ngRedux.dispatch((0, _stages.moveEvent)(this.feis.id, sourceStage.get('id'), targetStage.get('id'), item.toJS(), before ? before.get('id') : undefined, after ? after.get('id') : undefined));
        } else {
          this._.$ngRedux.dispatch((0, _stages.detachEvent)(this.feis.id, sourceStage.get('id'), item.toJS()));
        }
      } else if (attach) {
        this._.$ngRedux.dispatch((0, _stages.attachEvent)(this.feis.id, targetStage.get('id'), item.toJS(), before ? before.get('id') : undefined, after ? after.get('id') : undefined));
      }
    }
  }]);

  return StageScheduleController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.schedule', ['ngMaterial', 'ui.router', 'as.sortable', 'ifeis.stages.service', 'ifeis.stages.actions', 'ifeis.stages.store', 'ifeis.events', 'ifeis.prompt', 'ifeis.syllabi.editor', 'ifeis.csv']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.schedule', {
    url: '/schedule',
    controller: StageScheduleController,
    controllerAs: 'schedule',
    template: require('./tpl.html'),
    ncyBreadcrumb: {
      label: 'Schedule',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/schedule/index.js
// module id = 568
// module chunks = 0